



















































import { Component, Vue, Watch } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import BookingSummary from '@/components/Bookings/BookingDetails.vue';
import BookingManage from '@/components/Bookings/BookingWorkers.vue';
import BookingBookedWorkers from '@/components/BookingRoleWorkers/BookingBookedWorkers.vue';
import BookingManageWorkers from '@/components/BookingRoleWorkers/BookingManageWorkers.vue';
import BookingBrowseWorkers from '@/components/BookingRoleWorkers/BookingBrowseWorkers.vue';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import DateTimeUtils from '@/lib/dateTimeUtils';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'BookingManage',
  components: { Alert, BookingSummary, BookingManage, BookingBrowseWorkers, BookingManageWorkers, BookingBookedWorkers }
})
export default class extends GiganautVue {

    public role: BookingRoleDto = null;

	get currentBooking() {
		return BookingDetailsModule.currentBooking;
    }

    get roleDatesSummary() {
        let dates = "";
        for (let i=0; i < this.role.shifts.length; i++) {
            if (i !== 0) {
                dates += ", ";
			}
            dates += DateTimeUtils.toShortDate(new Date(this.role.shifts[i].startAt));
        }
        return dates;
    }
}
